import React, { useState } from "react";

const AMBER = "rgb(255, 179, 0)";

export default function ColumnSelectOverlay({
    x,
    y,
    width,
    height,
    selected,
    onToggle,
}) {
    const [hovered, setHovered] = useState(false);
    const fillOpacity = selected ? 0.18 : hovered ? 0.09 : 0;

    return (
        <rect
            x={x}
            y={y}
            width={width}
            height={height}
            rx="4"
            ry="4"
            fill={AMBER}
            fillOpacity={fillOpacity}
            stroke={selected ? AMBER : "transparent"}
            strokeWidth={selected ? 2 : 0}
            style={{ cursor: "pointer", pointerEvents: "all" }}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            onClick={(event) => {
                onToggle();
                event.stopPropagation();
            }}
        />
    );
}
